import { TiptapOutputType, getHTML } from '@amzn/awscat-editor';

import EnvironmentConfig from '../common/EnvironmentConfig';
import { IMplServiceClient } from '../api/IMplServiceClient';

const CODE_BLOCK_TYPE = 'codeBlock';

export const sanitizeCodeBlock = (model: TiptapOutputType) => {
  if (typeof model === 'string') {
    return model;
  }
  const content = model?.content ?? [];
  // @ts-expect-error TS7006 - strict migration
  content.forEach((sections) => {
    if (sections?.type === CODE_BLOCK_TYPE) {
      // @ts-expect-error TS7006 - strict migration
      sections?.content?.forEach((section) => {
        if (section.text) {
          // replace two characters which will not render correctly in code editor with regular space
          section.text = section.text.replace(/(\x20|\xA0)/g, ' ');
        }
      });
    }
  });
  return model;
};

export enum TiptapMenuType {
  Full = 'Full',
  Hide = 'Hide',
  Simple = 'Simple',
  OnlyLink = 'OnlyLink',
}

// Section titles are Tiptap Editors
// Convert string/object section titles to string section titles
export const getPathTitle = (path: string | object): string => {
  const titleHTML = getHTML(path);
  const title = titleHTML.replace(/<\/?[^>]+(>|$)/g, '');
  return title;
};

/**
 * Fetches an image and converts it to base64 format for embedding in content.
 *
 * This function handles images stored in the APGL database by:
 * 1. Checking if the image URL is hosted on the MPL service endpoints
 * 2. Normalizing API Gateway URLs to use the custom domain endpoint
 * 3. Fetching the image through the MPL service client
 * 4. Converting the image to base64 format for inline embedding
 *
 * @param srcUrl - The source URL of the image to fetch
 * @param mplService - The MPL service client instance used to fetch the image
 *
 * @returns A promise that resolves to either:
 *          - The original URL if the image is not hosted on MPL service endpoints (external images)
 *          - A base64-encoded string of the image data if hosted on MPL service endpoints
 */
export const fetchImageInBase64Format = async (srcUrl: string, mplService: IMplServiceClient) => {
  let imageUrl = srcUrl;
  const mplServiceEndpoint = EnvironmentConfig.getConfig().mplServiceEndpoint;
  // TODO: remove mplServiceAPIGatewayEndpoint after image url has been replaced with custom domain
  const mplServiceAPIGatewayEndpoint =
    EnvironmentConfig.getConfig().mplServiceAPIGatewayEndpoint ?? mplServiceEndpoint;
  // Only fetch images through mplServiceEndpoint hosted in APGL database
  if (!imageUrl.includes(mplServiceEndpoint) && !imageUrl.includes(mplServiceAPIGatewayEndpoint)) {
    return imageUrl;
  }
  if (imageUrl.includes(mplServiceAPIGatewayEndpoint)) {
    imageUrl = imageUrl.replace(mplServiceAPIGatewayEndpoint, mplServiceEndpoint);
  }
  const imageInBase64Format = await mplService.fetchContentImage(imageUrl);
  return imageInBase64Format;
};
